export class FailedPaymentError extends Error {
  constructor(message: string) {
    super();
    this.message = message;
    this.name = 'FailedPaymentError';
  }
}
